import React from 'react'

export const VenuePageV2 = () => {
  return (
    <div className="flex h-screen flex-col">
      <div className="fixed top-0 flex h-[160px] w-full items-center justify-center border-2 border-neutral-800 bg-surface">
        Venue image
      </div>
      <div className="z-10 flex-grow pt-[140px]">
        <div className="flex min-h-full flex-col space-y-4 divide-y overflow-auto rounded-t-3xl border-2 border-neutral-800 bg-surface pb-14 pt-2">
          <div className="px-4 pt-4">Name and logo component</div>
          <div className="px-4 pt-4">Personalised reorder component</div>
          <div className="px-4 pt-4">Browse menu component</div>
        </div>
      </div>
      <div className="fixed bottom-0 z-20 flex h-14 w-full items-center justify-center border-2 border-neutral-800 bg-surface">
        footer
      </div>
    </div>
  )
}
